import AspectRatio from '@blocks/AspectRatio'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import React from 'react'
import styled from 'styled-components'

export default function GalleryPhoto({ data: photo }: Props) {
    return (
        <Grid gap="10px">
            <AspectRatio height={photo.height} width={photo.width}>
                <ImageWrapper>
                    <ImageContainer src={photo.url} />
                </ImageWrapper>
            </AspectRatio>
            <Grid gap="5px">
                <PhotoHeading>{photo.title}</PhotoHeading>
                <p>{photo.first_name} {photo.last_name}</p>
                <small>{photo.section} • {photo.country}</small>
                <Flex justifyContent="flex-start"><small>Original: <a href={photo.url} target="_blank">{photo.width}x{photo.height}px</a></small></Flex>
            </Grid>
        </Grid>
    )
}

interface Props {
    data: General.Resources.AcceptanceGallery
}

// STYLES
const PhotoHeading = styled.h4<{ onClick?: any }>`
    cursor: ${props => props.onClick ? "pointer" : "auto"};
    overflow: hidden;
    text-overflow: ellipsis;
`

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

const ImageContainer = styled.div<{ src: string, onClick?: any }>`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${({ src }) => `url(${src}) center center no-repeat`};
    background-size: cover;
    border-radius: 5px;
    cursor: ${props => props.onClick ? "pointer" : "auto"};
`